import script from "./NineStarInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./NineStarInformation.vue?vue&type=script&setup=true&lang=js"

import "./NineStarInformation.vue?vue&type=style&index=0&id=dae335b6&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dae335b6"]])

export default __exports__